module.exports = __webpack_public_path__ + "img/avatar3.a7665947.svg";